import React from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import '../global/GlobalCSS.css';
import Layout from "HorizontalMenu/Menu";
import Navbar from "HorizontalMenu/Navbar";

const SingleReportView = () => {
    return (

        <React.Fragment>
            <Layout children={Navbar} />
            <div className="page-content">
                <Container fluid>
                    <CardHeader>
                        <div className="invoice-title">
                            <div className="pos-center">
                                <div className="mb-4">
                                    <h4 className="text-center font-size-16">
                                        Noon Report - 10/01/2023
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </CardHeader>
                    {/* */}
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Vessel Information</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Vessel name:</h5>
                                        <p className="text-center">Vessel 1</p>
                                    </div>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">IMO number:</h5>
                                        <p className="text-center">1111111</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Vessel Type:</h5>
                                        <p className="text-center">Tanker</p>
                                    </div>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Flag:</h5>
                                        <p className="text-center">India</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Deadweight (mt):</h5>
                                        <p className="text-center">100000</p>
                                    </div>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Year of built:</h5>
                                        <p className="text-center">2024</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    {/* */}
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Reporting Information</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Voyage number:</h5>
                                        <p className="text-center">0101-2024</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Position(Lat):</h5>
                                        <p className="text-center">10<sup>o</sup> 52' 64" N</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Position(Long):</h5>
                                        <p className="text-center">10<sup>o</sup> 52' 64" E</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Reporting time(UTC):</h5>
                                        <p className="text-center">Jan 01, 2024, 12:00</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Difference between local time & UTC:</h5>
                                        <p className="text-center">- 01:00</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Retarded/Advanced:</h5>
                                        <p className="text-center">0</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Is this noon report?:</h5>
                                        <p className="text-center">Yes</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Is this a beginning of CII adjustment event:</h5>
                                        <p className="text-center">Yes</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Reporting Type:</h5>
                                        <p className="text-center">At Sea</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Last reporting event:</h5>
                                        <p className="text-center">Noon</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Last reporting operation:</h5>
                                        <p className="text-center">Sea Passage</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Last reporting engine state:</h5>
                                        <p className="text-center">Ring full away</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Reporting event:</h5>
                                        <p className="text-center">Noon</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Operation since last report:</h5>
                                        <p className="text-center">Sea Passage</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Is strait-canal transit:</h5>
                                        <p className="text-center">No</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Strait canal transit:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Vessel load condition:</h5>
                                        <p className="text-center">Ballast</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Remaining distance to the next port:</h5>
                                        <p className="text-center">125</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Weather Data</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Distance travelled:</h5>
                                        <p className="text-center">18</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Water speed:</h5>
                                        <p className="text-center">10</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Wind direction:</h5>
                                        <p className="text-center">225</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Wind speed:</h5>
                                        <p className="text-center">4</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Beaufort scale:</h5>
                                        <p className="text-center">2</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Swell direction:</h5>
                                        <p className="text-center">West</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Swell height:</h5>
                                        <p className="text-center">0.8</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Ocean current's speed:</h5>
                                        <p className="text-center">0.2</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Ocean wave height:</h5>
                                        <p className="text-center">0.8</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Sea force:</h5>
                                        <p className="text-center">3</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Ocean current's direction:</h5>
                                        <p className="text-center">North</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Period in bad weather:</h5>
                                        <p className="text-center">0</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Air temperature:</h5>
                                        <p className="text-center">8</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Sea temperature:</h5>
                                        <p className="text-center">12</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Gyro course:</h5>
                                        <p className="text-center">240</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">CII Adjustment Events</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Current CII adjustment event:</h5>
                                        <p className="text-center">Search and Rescue</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Start time:</h5>
                                        <p className="text-center">2023-01-09 01:06</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">End time:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">STS Operation</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Loading:</h5>
                                        <p className="text-center">Yes</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Start date & time:</h5>
                                        <p className="text-center">2023-01-09 01:06</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">End date & time:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Discharging:</h5>
                                        <p className="text-center">No</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Start date & time:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">End date & time:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">CP Warranties</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Ordered speed:</h5>
                                        <p className="text-center">12.5</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Is there any change since last report:</h5>
                                        <p className="text-center">No</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Date & time of change:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Fuel type:</h5>
                                        <p className="text-center">Diesel oil</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Ordered fuel consumed:</h5>
                                        <p className="text-center">24 mt/day</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Fuel type:</h5>
                                        <p className="text-center">Fuel oil</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Ordered fuel consumed:</h5>
                                        <p className="text-center">0.2 mt/day</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Draft & Displacement</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Fwd draft:</h5>
                                        <p className="text-center">13.5</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Mid draft:</h5>
                                        <p className="text-center">13.5</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Aft draft:</h5>
                                        <p className="text-center">13.5</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Displacement:</h5>
                                        <p className="text-center">21000</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Cargo Details</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Cargo details:</h5>
                                        <p className="text-center">Molases</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Amount of cargo loaded:</h5>
                                        <p className="text-center">6000</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Amount of cargo discharged:</h5>
                                        <p className="text-center">0</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Total cargo onboard:</h5>
                                        <p className="text-center">44000</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Bill of Lading</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Is bill of lading issued since last report:</h5>
                                        <p className="text-center">Yes</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">BL figures:</h5>
                                        <p className="text-center">44000</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Ship figures(BL figures):</h5>
                                        <p className="text-center">44000</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Cargo survey:</h5>
                                        <p className="text-center">No</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Surveyor figures(BL figures):</h5>
                                        <p className="text-center">0</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Expected Time of Arrival/Departure</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Arrival port name:</h5>
                                        <p className="text-center">Casablanca</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Master's ETA at pilot station:</h5>
                                        <p className="text-center">09-01-2023 01:06</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Is arrival port in ECA and vessel is yet to enter the region:</h5>
                                        <p className="text-center">No</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Expected time of arrival at ECA:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Departure port name:</h5>
                                        <p className="text-center">Casablanca</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Master's ETD from present port:</h5>
                                        <p className="text-center">13-01-2023 01:06</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Is departure port in ECA and vessel is yet to exit the region:</h5>
                                        <p className="text-center">No</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Expected time of arrival at ECA:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Will vessel transit ECA region:</h5>
                                        <p className="text-center">No</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Date & time of arrival at ECA incase vessel is yet to enter the region:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Date & time of departure from ECA:</h5>
                                        <p className="text-center">-</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Fuel Consumption & ROB</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Machinery name</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel oil</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Diesel oil</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Main Engine</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">1.5</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">2.8</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Auxiliary Engine</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0.8</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Boiler</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">1.8</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Inert Gas Generator</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">HPP 1 and HPP 2</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                </Col>
                                <Col lg={4}>
                                    <h5 className="font-size-15 text-center mb-0">Fuel oil- 1.5</h5>
                                </Col>
                                <Col lg={4}>
                                    <h5 className="font-size-15 text-center mb-0">Diesel oil- 5.4</h5>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Fuel Consumption- Batch</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={3}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel name</h5>
                                    </Col>
                                    <Col lg={3}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel batches</h5>
                                    </Col>
                                    <Col lg={3}>
                                        <h5 className="font-size-15 text-center mb-0">ROB</h5>
                                    </Col>
                                    <Col lg={3}>
                                        <h5 className="font-size-15 text-center mb-0">Consumption</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={3}>
                                    <p className="text-center">Fuel oil</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">VLSFO/Amsterdam/201/1/2023-01-08</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">750 mt</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col></Col>
                                <Col lg={3}>
                                    <p className="text-center">VLSFO/Las Palmas/176/1/2022-12-31</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">68.3 mt</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={3}>
                                    <p className="text-center">Diesel oil</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">ULSGO/Amsterdam/201/2/2023-01-08</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">240 mt</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">5.4 mt</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col></Col>
                                <Col lg={3}>
                                    <p className="text-center">ULSGO/Amsterdam/176/1/2022-12-31</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">155 mt</p>
                                </Col>
                                <Col lg={3}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Bunkering</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Bunkering fuel type:</h5>
                                        <p className="text-center">Fuel oil</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Bunkered fuel:</h5>
                                        <p className="text-center">Very low sulphur fuel oil</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Quantity bunkered:</h5>
                                        <p className="text-center">255 mt</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Fuel density:</h5>
                                        <p className="text-center">0 kg/m<sup>3</sup>@15<sup>0</sup>C</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Sulphur percentage:</h5>
                                        <p className="text-center">0 %m/m</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Viscosity:</h5>
                                        <p className="text-center">0 cst@50<sup>0</sup>C</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Port of bunkering:</h5>
                                        <p className="text-center">Amsterdam</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Date of bunkering:</h5>
                                        <p className="text-center">09-01-2023</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Fuel Debunkering</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Col lg={3}>
                                <div className="ele_row1">
                                    <h5 className="font-size-15 text-center mr-1">Port of debunkering:</h5>
                                    <p className="text-center">Amsterdam</p>
                                </div>
                            </Col>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel name</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel batches</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Quantity debunkered</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">ROB</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Date of debunkering</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">Fuel oil</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">VLSFO/Amsterdam/201/1/2023-01-08</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">50</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">750</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">09-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}></Col>
                                <Col lg={2}>
                                    <p className="text-center">VLSFO/Las Palmas/176/1/2022-12-31</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">68.3</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">Diesel oil</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">ULSGO/Amsterdam/201/2/2023-01-08</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">40</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">240</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">09-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}></Col>
                                <Col lg={2}>
                                    <p className="text-center">ULSGO/Amsterdam/176/1/2022-12-31</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">155.3</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Lube Oil Bunkering</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Col lg={3}>
                                <div className="ele_row1">
                                    <h5 className="font-size-15 text-center mr-1">Port of bunkering:</h5>
                                    <p className="text-center">Amsterdam</p>
                                </div>
                            </Col>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Lube oil name</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Quantity bunkered</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Date of bunkering</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Main engine system oil</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Cylinder oil</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Auxiliary engine sytem oil</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Other lubricants</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Lube Oil Debunkering</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Col lg={3}>
                                <div className="ele_row1">
                                    <h5 className="font-size-15 text-center mr-1">Port of debunkering:</h5>
                                    <p className="text-center">-</p>
                                </div>
                            </Col>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Lube oil name</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Quantity bunkered</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Date of bunkering</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Main engine system oil</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Cylinder oil</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Auxiliary engine sytem oil</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Other lubricants</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">DD-01-2023</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Fresh Water</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Amount of fresh water produced:</h5>
                                        <p className="text-center">0 mt</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Amount of fresh water received:</h5>
                                        <p className="text-center">0 mt</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Amount of domestic water consumed:</h5>
                                        <p className="text-center">1 mt</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Amount of distilled water consumed</h5>
                                        <p className="text-center">0</p>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="ele_row1">
                                        <h5 className="font-size-15 text-center mr-1">Fresh water ROB:</h5>
                                        <p className="text-center">149 mt</p>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Lube Oil ROB</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={6}>
                                        <h5 className="font-size-15 text-center mb-0">Lube oil name</h5>
                                    </Col>
                                    <Col lg={6}>
                                        <h5 className="font-size-15 text-center mb-0">Lube oil ROB</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={6}>
                                    <p className="text-center">Main engine system oil</p>
                                </Col>
                                <Col lg={6}>
                                    <p className="text-center">18530</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <p className="text-center">Cylinder oil</p>
                                </Col>
                                <Col lg={6}>
                                    <p className="text-center">23430</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <p className="text-center">Auxiliary engine sytem oil</p>
                                </Col>
                                <Col lg={6}>
                                    <p className="text-center">9480</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <p className="text-center">Other lubricants</p>
                                </Col>
                                <Col lg={6}>
                                    <p className="text-center">12950</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Special Operations- Cargo Heating</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Machinery name</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel oil</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Diesel oil</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Boiler</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Special Operations- Tank Cleaning</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Machinery name</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel oil</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Diesel oil</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">HPP 1 and HPP 2</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Inert Gas Generator</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Boiler</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Auxiliary Engine</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Special Operations- Cargo Discharging</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Machinery name</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Fuel oil</h5>
                                    </Col>
                                    <Col lg={4}>
                                        <h5 className="font-size-15 text-center mb-0">Diesel oil</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">HPP 1 and HPP 2</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Inert Gas Generator</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className="text-center">Auxiliary Engine</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">0 mt</p>
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                                <Col lg={4}>
                                    <p className="text-center">Max consumption- 0</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Energy consumption without kWh meter</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Col lg={4}>
                                <div className="ele_row1">
                                    <h5 className="font-size-15 text-center mr-1">Hydraulic Power Pack 4</h5>
                                </div>
                            </Col>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Period</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Hours of cargo discharging</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">V</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">I</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Pf</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">W=kWh</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">1200-1600</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">1600-2000</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">2000-2400</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">0000-0400</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">0400-0800</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">0800-1200</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader className="ptb10">
                            <div className="text-center">
                                <h5 className="primary-label mb-0">Energy consumption without kWh meter</h5>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Col lg={4}>
                                <div className="ele_row1">
                                    <h5 className="font-size-15 text-center mr-1">Hydraulic Power Pack 3</h5>
                                </div>
                            </Col>
                            <div className="bg-primary-subtle ptb10">
                                <Row>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Period</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Hours of cargo discharging</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">V</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">I</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">Pf</h5>
                                    </Col>
                                    <Col lg={2}>
                                        <h5 className="font-size-15 text-center mb-0">W=kWh</h5>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">1200-1600</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">1600-2000</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">2000-2400</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">0000-0400</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">0400-0800</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    <p className="text-center">0800-1200</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0 hr</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                                <Col lg={2}>
                                    <p className="text-center">0</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment >
    )
}
export default SingleReportView